import { FormConfigs } from 'components/Molecules/Forms/WithFieldConfigs/index';
import React from 'react';
import { generateFieldPosition, generateFields, initValue } from '../../../helper';
import { Middlewares } from '../../../middlewares/index';
import Input from '../../../Fields/Input';
import Checkbox from '../../../Fields/Checkbox';
import TextArea from '../../../Fields/TextArea';
import { ReferenceFile } from '../../../Fields/ReferenceFile';
import classes from './FormItem.module.scss';

export const CheckListItem = (props) => {
  const { fields, configs, ordinal } = props;
  const initialValues = initValue(fields, configs);

  const generatedFields = generateFields([...fields], configs);

  return (
    <div>
      <FormConfigs
        className={classes.form}
        disabled
        layout="vertical"
        initialValues={initialValues}
        FIELD_PROVIDER={{
          INPUT: Input,
          CHECKBOX: Checkbox,
          TEXTAREA: TextArea,
          UPLOAD: ReferenceFile,
        }}
        fields={generateFieldPosition(generatedFields, {})}
        middlewares={[
          ...Middlewares,
          (field) => {
            if (field.name.includes('checkPointName')) {
              return {
                ...field,
                label: (
                  <div>
                    <span style={{ width: 34, paddingRight: 8, display: 'inline-block' }}>
                      #{ordinal}
                    </span>
                    <span>Check Point Name</span>
                  </div>
                ),
              };
            }
            return field;
          },
        ]}
        renderMiddlewares={[
          (sectionField, meta) => {
            const { FIELD_PROVIDER } = meta;
            const Element = FIELD_PROVIDER[sectionField.type];
            if (!Element) return null;
            return <Element {...sectionField} {...meta} />;
          },
        ]}
      />
    </div>
  );
};
